// extracted by mini-css-extract-plugin
module.exports = {"triggerContainer":"VideoInline-module--triggerContainer--3q-Zz","iframeWrapper":"VideoInline-module--iframeWrapper--c0EdU"};